import React from 'react';
import { convictionLabel } from '../utils/convictionLabel';
import Badge from './Badge';
import ScoreGauge from './ScoreGauge';
import ConvictionBand from './ConvictionBand';
import './Recommendations.css';

// Fallback band (color class) from the one label scale; was 75/60/45.
const BAND_FOR_LABEL = { Favorable: 'High', Promising: 'High-Medium', Neutral: 'Medium',
  Cautious: 'Medium-Low', Unfavorable: 'Low' };

const Recommendations = ({ recommendations }) => {
  const formatScore = (score) => {
    if (score === null || score === undefined) return '—';
    return score.toFixed(1);
  };

  return (
    <div className="card recommendations-card">
      <h2>Portfolio Recommendations</h2>
      
      {recommendations.length === 0 ? (
        <p className="no-recommendations">
          No recommendations available yet. Upload and analyze your portfolio first.
        </p>
      ) : (
        <div className="recommendations-grid">
          {recommendations.map((rec, index) => (
            <div key={rec.symbol} className="recommendation-card">
              <div className="rec-header">
                <div className="rec-symbol-section">
                  <h3 className="rec-symbol">{rec.symbol}</h3>
                  {index === 0 && (
                    <span className="rec-top-badge">🏆 Top Pick</span>
                  )}
                </div>
                <Badge type={rec.recommendation} size="medium" />
              </div>
              
              <div className="rec-conviction">
                <ConvictionBand
                  band={rec.conviction_band || BAND_FOR_LABEL[convictionLabel(rec.total_score)]}
                  score={rec.total_score}
                  size="medium"
                />
              </div>

              {/* Mobile-only compact score row. Hidden on desktop.
                  Shows all the same numbers as the gauge sections above
                  in a single scannable line so mobile users can read a
                  recommendation without excessive scrolling. */}
              <div className="rec-mobile-compact">
                <div className="rec-mobile-conv">
                  <span className="rec-mobile-conv-value">{formatScore(rec.total_score)}</span>
                  <span className="rec-mobile-conv-label">Conviction</span>
                </div>
                <div className="rec-mobile-scores">
                  <span className="rec-mobile-score"><span>Q</span>{formatScore(rec.stock_quality_score)}</span>
                  <span className="rec-mobile-score"><span>S</span>{formatScore(rec.stock_setup_score)}</span>
                  <span className="rec-mobile-score"><span>C</span>{formatScore(rec.convex_radar_score)}</span>
                  <span className="rec-mobile-score"><span>E</span>{formatScore(rec.energy_matrix_score)}</span>
                </div>
              </div>

              <div className="rec-scores">
                <div className="rec-score-row">
                  <ScoreGauge 
                    value={rec.stock_quality_score} 
                    label="Quality" 
                    size="small"
                  />
                </div>
                <div className="rec-score-row">
                  <ScoreGauge 
                    value={rec.stock_setup_score} 
                    label="Setup" 
                    size="small"
                  />
                </div>
                <div className="rec-score-row-split">
                  <div className="rec-score-mini">
                    <span className="score-label">Convex</span>
                    <span className="score-value">{formatScore(rec.convex_radar_score)}/5</span>
                  </div>
                  <div className="rec-score-mini">
                    <span className="score-label">Energy</span>
                    <span className="score-value">{formatScore(rec.energy_matrix_score)}/5</span>
                  </div>
                </div>
              </div>
              
              {rec.recommendation_reason && (
                <div className="rec-reason">
                  <p>{rec.recommendation_reason}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Recommendations;
